var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.97659 9.50326H10.5033L13.8299 12.8366L12.8366 13.8299L9.50326 10.5033V9.97659L9.32326 9.78992C8.56326 10.4433 7.57659 10.8366 6.50326 10.8366C4.10992 10.8366 2.16992 8.89659 2.16992 6.50326C2.16992 4.10992 4.10992 2.16992 6.50326 2.16992C8.89659 2.16992 10.8366 4.10992 10.8366 6.50326C10.8366 7.57659 10.4433 8.56326 9.78992 9.32326L9.97659 9.50326ZM3.50371 6.50337C3.50371 8.16337 4.84371 9.50337 6.50371 9.50337C8.16371 9.50337 9.50371 8.16337 9.50371 6.50337C9.50371 4.84337 8.16371 3.50337 6.50371 3.50337C4.84371 3.50337 3.50371 4.84337 3.50371 6.50337Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.1bb7c413264a842b180c271359e28fa1.svg";
export { ForwardRef as ReactComponent };